import { render } from "./PaymentItem.vue?vue&type=template&id=1a27a967&scoped=true"
import script from "./PaymentItem.vue?vue&type=script&lang=js"
export * from "./PaymentItem.vue?vue&type=script&lang=js"

import "./PaymentItem.vue?vue&type=style&index=0&id=1a27a967&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a27a967"]])

export default __exports__